import { routes as home } from '@/pages/home';
import { routes as dashboard } from '@/pages/dashboard';
import { routes as mailing } from '@/pages/landing';
import { routes as pesquisa } from '@/pages/pesquisa';
import { routes as siscobra } from '@/pages/siscobra';
import { routes as genericLogin } from '@/pages/generic-login';

export default [
    ...home,
    ...dashboard,
    ...mailing,
    ...pesquisa,
    ...siscobra,
    ...genericLogin,
    // DX-2201: link curto de acesso (baseURL + código de 9 caracteres), ex:
    // https://regularizaboticario.com.br/O2ZaoswZl. Precisa ficar depois de todas
    // as rotas específicas acima (vue-router 3 casa por ordem de registro, não
    // especificidade) e antes do catch-all de 404, senão engoliria rotas como
    // /dashboard, /login etc.
    {
        path: "/:shortCode",
        component: () => import("@/modules/layout/HomeLayout"),
        children: [
            {
                path: "",
                name: "shortLinkAccess",
                component: () => import("@/pages/home/Home"),
            },
        ],
    },
    {
        path: "/:pathMatch(.*)",
        name: "notFound",
        component: () =>
          import("@/pages/NotFound"),
    },
];
